/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChartSeriesSchema } from './chart-series-schema';


export interface ChartConfigurationSchema { 
    /**
     * Column name from the query result to use for the X-axis.
     */
    xAxis: string;
    /**
     * Y-axis series configuration. Each series column must exist in the query result.
     */
    ySeries: Array<ChartSeriesSchema>;
    /**
     * Chart orientation.
     */
    orientation: ChartConfigurationSchema.OrientationEnum;
    /**
     * Default time grain for time-series aggregation.
     */
    defaultTimeGrain?: ChartConfigurationSchema.DefaultTimeGrainEnum;
}
export namespace ChartConfigurationSchema {
    export const OrientationEnum = {
        Vertical: 'vertical',
        Horizontal: 'horizontal'
    } as const;
    export type OrientationEnum = typeof OrientationEnum[keyof typeof OrientationEnum];
    export const DefaultTimeGrainEnum = {
        Daily: 'daily',
        Weekly: 'weekly',
        Monthly: 'monthly',
        Quarterly: 'quarterly',
        Yearly: 'yearly'
    } as const;
    export type DefaultTimeGrainEnum = typeof DefaultTimeGrainEnum[keyof typeof DefaultTimeGrainEnum];
}


